import { Directive, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[convertArabicNumbers]',
})
export class ConvertArabicNumbersDirective {
  @Output() ngModelChange = new EventEmitter();

  constructor(private el: ElementRef) {
  }

  @HostListener('input')
  onChange() {
    const val =  this.el.nativeElement.value;
    const newVal = val.replace(/[\u0660-\u0669]/g, (char: string) => {
      return (char.charCodeAt(0) - 0x0660).toString();
    });

    if ( val !== newVal) {
      this.el.nativeElement.value = newVal;
      this.el.nativeElement.dispatchEvent(new Event('input'));
    }
  }
}
